import type {Template} from '@helpers//select-template';

import {chooseAndCloneTemplate} from '@helpers/select-template';

import {
  DEFAULT_FRONTEND_NEXT_DASHBOARD_HEROUI_PROJECT_NAME,
  DEFAULT_FRONTEND_NEXT_DASHBOARD_SHADCN_PROJECT_NAME,
  DEFAULT_FRONTEND_NEXT_DOCS_FUMADOCS_PROJECT_NAME,
  DEFAULT_FRONTEND_NEXT_LANDING_HEROUI_PROJECT_NAME,
  DEFAULT_FRONTEND_NEXT_LANDING_SHADCN_PROJECT_NAME,
  FRONTEND_NEXT_DASHBOARD_HEROUI_REPO,
  FRONTEND_NEXT_DASHBOARD_SHADCN_REPO,
  FRONTEND_NEXT_DOCS_FUMADOCS_REPO,
  FRONTEND_NEXT_LANDING_HEROUI_REPO,
  FRONTEND_NEXT_LANDING_SHADCN_REPO
} from '../constants/templates';

export const initFrontend = async (): Promise<void> => {
  const templates: Template[] = [
    {
      name: DEFAULT_FRONTEND_NEXT_LANDING_HEROUI_PROJECT_NAME,
      repo: FRONTEND_NEXT_LANDING_HEROUI_REPO
    },
    {
      name: DEFAULT_FRONTEND_NEXT_LANDING_SHADCN_PROJECT_NAME,
      repo: FRONTEND_NEXT_LANDING_SHADCN_REPO
    },
    {
      name: DEFAULT_FRONTEND_NEXT_DOCS_FUMADOCS_PROJECT_NAME,
      repo: FRONTEND_NEXT_DOCS_FUMADOCS_REPO
    },
    {
      name: DEFAULT_FRONTEND_NEXT_DASHBOARD_HEROUI_PROJECT_NAME,
      repo: FRONTEND_NEXT_DASHBOARD_HEROUI_REPO
    },
    {
      name: DEFAULT_FRONTEND_NEXT_DASHBOARD_SHADCN_PROJECT_NAME,
      repo: FRONTEND_NEXT_DASHBOARD_SHADCN_REPO
    }
  ];

  await chooseAndCloneTemplate(templates);
};
